<template>
<div>
  <h4 class="title-bar">기간 범위 선택</h4>
  <el-form :inline="true" label-position="left">
    <el-radio-group v-model="period">
      <el-radio label="day">일간</el-radio>
      <el-radio label="week"> 주간</el-radio>
      <el-radio label="month">월간</el-radio>
      <el-radio label="year">연간</el-radio>
    </el-radio-group>
    <div class="mr-t10 mr-b25">
      기간 A
      <el-date-picker class="mr-r15" style="width:150px;" v-model="periodA.date" type="date" placeholder="기간 A" :picker-options="{ disabledDate }" />
      기간 B
      <el-date-picker style="width:150px;" v-model="periodB.date" type="date" placeholder="기간 B" :picker-options="{ disabledDate }" />
      <el-button type="primary" size="mini" @click="onClickSubmitButton">조회하기</el-button>
    </div>
  </el-form>
  <hr/>
  <h4 class="mr-t20 mr-b10 mr-r4">기간 A <em class="mr-l4">{{ periodA.description }}</em></h4>
  <w-period-line-chart :rscInfoList="rscInfoList" :dateParams="periodA.dateParams" />
  <h4 class="title-bar">기간 B <em class="mr-l4">{{ periodB.description }}</em></h4>
  <w-period-line-chart :rscInfoList="rscInfoList" :dateParams="periodB.dateParams" />
</div>
</template>

<script>
import clone from 'lodash/clone';

import { isEmpty } from '@/utils/basic';
import { getRequestDatetimeParams, getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import WPeriodLineChart from './components/PeriodLineChart';

export default {
  name: 'WPeriodAbsoluteView',
  components: {
    WPeriodLineChart,
  },
  props: {
    rscInfoList: Array,
  },
  data() {
    return {
      period: 'day',
      periodA: {
        date: new Date(),
        dateParams: {},
        description: null,
      },
      periodB: {
        date: null,
        dateParams: {},
        description: null,
      },
      periodObject: {
        day: '일간',
        week: '주간',
        month: '월간',
        year: '연간',
      },
    };
  },
  watch: {
    rscInfoList: {
      immediate: true,
      handler() {
        if (isEmpty(this.periodB.date)) {
          const today = new Date();
          const periodB = today.setDate(today.getDate() - 1);
          this.periodB.date = new Date(periodB);
        }

        this.onClickSubmitButton();
      },
    },
  },
  methods: {
    /**
     * 기간 범위 선택후 조회하기 버튼을 클릭한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickSubmitButton() {
      const periodA = this.periodA.date;
      const periodB = this.periodB.date;

      if (isEmpty(periodA) || isEmpty(periodB)) {
        this.$message(msgUtil.getCustomMsgData('기간을 설정해주십시오.'));
        return;
      }
      const periodAParams = this.getPeriodParams(periodA);
      const periodBParams = this.getPeriodParams(periodB);

      this.periodA = {
        date: periodA,
        dateParams: periodAParams,
        description: this.getPeriodDescription(periodA, periodAParams),
      };

      this.periodB = {
        date: periodB,
        dateParams: periodBParams,
        description: this.getPeriodDescription(periodB, periodBParams),
      };
    },
    /**
     * 기간 별 startDatetime, endDatetime을 가져온다.
     * @param  {[type]} datetime [description]
     * @return {[type]}          [description]
     * @author jda
     */
    getPeriodParams(periodDatetime) {
      const datetime = clone(periodDatetime);
      let startDatetime;
      let endDatetime;
      switch (this.period) {
        case 'day': {
          startDatetime = datetime;
          endDatetime = datetime;
          break;
        }

        case 'week': {
          startDatetime = new Date(datetime.setDate(datetime.getDate() - datetime.getDay()));
          endDatetime = new Date(datetime.setDate(startDatetime.getDate() + 6));
          break;
        }

        case 'month': {
          startDatetime = new Date(datetime.setDate(1));
          endDatetime = new Date(datetime.getFullYear(), datetime.getMonth() + 1, 0);
          break;
        }

        case 'year': {
          startDatetime = new Date(datetime.getFullYear(), 0, 1);
          endDatetime = new Date(datetime.getFullYear(), 12, 0);
          break;
        }
        default:
          break;
      }

      endDatetime = endDatetime.setHours(23, 59, 59, 0);
      return {
        startDatetime: startDatetime.setHours(0, 0, 0, 0),
        endDatetime: getRequestDatetimeParams(endDatetime),
        originalEndDatetime: endDatetime,
      };
    },
    /**
     * 기간 Label설정.
     * @param  {[type]} datetime   [description]
     * @param  {[type]} dateParams [description]
     * @return {[type]}            [description]
     * @author jda
     */
    getPeriodDescription(datetime, dateParams) {
      const periodLabel = this.periodObject[this.period];

      let dateString;
      if (this.period === 'day') {
        dateString = getDateToString(datetime, 'YYYY-MM-DD');
      } else {
        dateString = `${getDateToString(dateParams.startDatetime, 'YYYY-MM-DD')} ~ ${getDateToString(dateParams.originalEndDatetime, 'YYYY-MM-DD')}`;
      }
      return `[${periodLabel} ${dateString}]`;
    },
    /**
     * date-picker에서 미래시간은 선택하지 못한다.
     * @param  {[type]} datetime [description]
     * @return {[type]}          [description]
     * @author jda
     */
    disabledDate(datetime) {
      return datetime > Date.now();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceComparePeriodPopup/PeriodAbsoluteView.vue